<template lang='pug' src='./home.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Modal from 'components/modal/modal'
import Hero from 'components/hero/hero'
import BlockIntro from 'components/block/block-intro/block-intro'
import BlockCtaModal from 'components/block/block-cta-modal/block-cta-modal'
import CustomHomeApart from 'components/custom/custom-home-apart/custom-home-apart'
import CustomHomeBanner from 'components/custom/custom-home-banner/custom-home-banner'
import CustomHomeTabs from 'components/custom/custom-home-tabs/custom-home-tabs'
import CustomHomeVideo from 'components/custom/custom-home-video/custom-home-video'
import DividerText from 'components/divider/divider-text/divider-text'
import SliderTestimonials from 'components/slider/slider-testimonials/slider-testimonials'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    },
    propsnew () {
      return this.$store.state.app
    }
  },
  components: {
    Loader,
    Modal,
    Hero,
    BlockIntro,
    BlockCtaModal,
    DividerText,
    CustomHomeApart,
    CustomHomeBanner,
    CustomHomeTabs,
    CustomHomeVideo,
    SliderTestimonials
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?609c77fa